import {
  Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges,
} from '@angular/core';
import * as calcloan from 'calcloan';

@Component({
  selector: 'app-how-we-compare',
  templateUrl: './how-we-compare.component.html',
  styleUrls: ['./how-we-compare.component.scss'],
})
export class HowWeCompareComponent implements OnInit, OnChanges {
  @Input('price') price: number;

  comparison: Calculator.Output;

  constructor() { }

  ngOnInit(): void {

  }

  async ngOnChanges(simpleChanges: SimpleChanges) {
    const change: SimpleChange = simpleChanges['price'];
    if (change.currentValue) {
      const price = change.currentValue;
      this.comparison = await calcloan.reverseCalculateBudget({
        case: 'WITH_PROPERTY_PRICE',
        property_price: price,
        loan_percent: 0.15,
      });
    } else {
      this.comparison = void 0;
    }
  }
}
